// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"6cefe11e","302":"43345a03","475":"56491224","554":"5d8c0565","580":"60799bbc","742":"3453b716","749":"b68568f9","761":"008eefe2","822":"8ca68da5","831":"f6651fec"}[chunkId] + ".chunk.js";
};